/* eslint-disable react/prop-types */
import { BsMegaphone } from "react-icons/bs";
import parse from "html-react-parser";

const AnnouncementMessage = ({ msg }) => {
  return (
    <div className="mb-3 rounded-md bg-orange-200 px-2 py-1 text-orange-500">
      <div className="flex flex-row gap-2">
        <BsMegaphone />
        <marquee direction="">
          <div className="text-xs">{parse(msg)}</div>
        </marquee>
      </div>
    </div>
  );
};

export default AnnouncementMessage;
